import {IController} from "angular";
import {SmsSettings} from "modules/user_settings/model/UserSettings";
import {initialiseSmsToneOption} from "modules/user_settings/model/InitialisedEmailRowOptions";
import {
    EnthusiasticToneConfig,
    PersuasiveToneConfig,
    ProfessionalismToneConfig,
    UrgencyToneConfig
} from "modules/user_settings/model/enums/enums";
import {ToastNotificationService} from "modules/utils/ToastNotificationService";
import {UserSettingsService, UserSettingsServiceName} from "modules/user_settings/service/UserSettingsService";
import {ToastNotificationServiceName} from "modules/utils/names/serviceNames";

import {EmailPreviewService, EmailPreviewServiceName} from "modules/user_settings/service/EmailPreviewService";
import {ToneOption} from "modules/user_settings/component/email-settings/email-tone-row/email-tone-row";

export interface ToneOptionBlock {
    groupName: string;
    toneOptions: Array<ToneOption>
    selectedValue: string;
}

export interface LengthOption {
    label: string;
    value: string;
}

export class SmsLeftSide implements IController {

    public smsToneOptions: Array<ToneOptionBlock>;
    public updatedSettings: SmsSettings;
    public isSaveEnabled: boolean = false;
    public includeEmoji: boolean;
    public settings: SmsSettings;
    public onSaveSettings: any;

    public static instance = {
        template: require('./left-side.html'),
        controller: [
            UserSettingsServiceName,
            EmailPreviewServiceName,
            ToastNotificationServiceName,
            SmsLeftSide
        ],
        bindings: {
            updatedSettings: '=',
            settings: '<',
            onSaveSettings: '&'
        },
    };

    constructor(
        private userSettingsService: UserSettingsService,
        private emailPreviewService: EmailPreviewService,
        private notificationService: ToastNotificationService
    ) {
    }

    $onInit() {
        this.updatedSettings = this.userSettingsService.cloneSettings(this.settings);
        this.includeEmoji = this.settings.includeEmoji;
        this.initializeToneOptions();
    }


    initializeToneOptions() {
        this.smsToneOptions = initialiseSmsToneOption(this.settings);
    }

    saveSettingsAndDeleteOutdatedPreview() {
        this.userSettingsService
            .saveSmsSettings(this.updatedSettings)
            .then((response) => {
                    this.isSaveEnabled = false;
                    this.settings = this.userSettingsService.cloneSettings(this.updatedSettings)
                    this.notificationService.generateSuccessMessage("Settings was updated successfully");
                }
            ).catch((error) => {
            console.error("Error updating settings", error);
        })
        this.emailPreviewService.deleteSmsPreview();
    }

    saveIncludingEmoji() {
        this.updatedSettings.includeEmoji = !this.updatedSettings.includeEmoji
        console.log(this.updatedSettings.includeEmoji)
        this.isSaveEnabled = this.userSettingsService.settingsChanged(this.updatedSettings, this.settings)
    }

    updateToneSetting(toneOption: ToneOptionBlock) {
        this.smsToneOptions
            .find(t => t.groupName == toneOption.groupName)
            .selectedValue = toneOption.selectedValue;
        switch (toneOption.groupName) {
            case "professionalismToneConfig":
                this.updatedSettings.professionalismToneConfig = toneOption.selectedValue as ProfessionalismToneConfig;
                break;
            case "enthusiasticToneConfig":
                this.updatedSettings.enthusiasticToneConfig = toneOption.selectedValue as EnthusiasticToneConfig;
                break;
            case "persuasiveToneConfig":
                this.updatedSettings.persuasiveToneConfig = toneOption.selectedValue as PersuasiveToneConfig;
                break;
            case "urgencyToneConfig":
                this.updatedSettings.urgencyToneConfig = toneOption.selectedValue as UrgencyToneConfig;
                break;
        }
        this.isSaveEnabled = this.userSettingsService.settingsChanged(this.updatedSettings, this.settings)
    }

    public updateEmailCallback = (selectedValue: string) => {
        this.isSaveEnabled = this.userSettingsService.settingsChanged(this.updatedSettings, this.settings)
    }

}
